import { useState } from "react";
import { currentTheme, toggleTheme, type Theme } from "../../lib/theme.ts";

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(currentTheme);
  return (
    <button
      type="button"
      className="theme-toggle"
      aria-pressed={theme === "dark"}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      onClick={() => setTheme(toggleTheme())}
    >
      {theme === "dark" ? "☀ light" : "☾ dark"}
    </button>
  );
}
